import { jsxs as w, jsx as n, Fragment as bt } from "react/jsx-runtime";
import { GridItem as q, Box as Ft, Grid as J } from "@chakra-ui/react";
import Gt, { useState as Q, useEffect as Tt, useCallback as Lt } from "react";
import { DatePickerDateCell as X } from "./date-picker-date-cell.js";
import { DatePickerHeader as Et } from "./date-picker-header.js";
import { DatePickerWeekCell as Pt } from "./date-picker-week-cell.js";
import { hasDotOnDate as h, isDateStrikeThrough as _t, getWeekCellVariant as zt, getDateCellVariant as Z, firstLetterUpperCase as At, hasDatePassed as Ht } from "./helper.js";
import { lv as Ut } from "../../node_modules/date-fns/locale/lv.js";
import { lt as jt } from "../../node_modules/date-fns/locale/lt.js";
import { et as Kt } from "../../node_modules/date-fns/locale/et.js";
import { es as Yt } from "../../node_modules/date-fns/locale/es.js";
import { fi as qt } from "../../node_modules/date-fns/locale/fi.js";
import { nl as Jt } from "../../node_modules/date-fns/locale/nl.js";
import { endOfMonth as N } from "../../node_modules/date-fns/endOfMonth.js";
import { startOfWeek as Qt } from "../../node_modules/date-fns/startOfWeek.js";
import { sv as Xt } from "../../node_modules/date-fns/locale/sv.js";
import { da as Zt } from "../../node_modules/date-fns/locale/da.js";
import { nb as Nt } from "../../node_modules/date-fns/locale/nb.js";
import { enGB as Rt } from "../../node_modules/date-fns/locale/en-GB.js";
import { enUS as tr } from "../../node_modules/date-fns/locale/en-US.js";
import { formatDate as R } from "../../node_modules/date-fns/format.js";
import { startOfMonth as x } from "../../node_modules/date-fns/startOfMonth.js";
import { addDays as tt } from "../../node_modules/date-fns/addDays.js";
import { isSameMonth as rt } from "../../node_modules/date-fns/isSameMonth.js";
import { isSameDay as f } from "../../node_modules/date-fns/isSameDay.js";
import { getISOWeek as et } from "../../node_modules/date-fns/getISOWeek.js";
import { ThemeColorVariable as ot, ThemeSpaceVariable as at, ThemeFontSizeVariable as rr, ThemeFontVariable as er } from "../../theme/theme-types.js";
const or = {
  "en-US": { locale: tr },
  "en-GB": { locale: Rt },
  "nb-NO": { locale: Nt },
  "da-DK": { locale: Zt },
  "sv-SE": { locale: Xt },
  "nl-NL": { locale: Jt },
  "fi-FI": { locale: qt },
  "es-ES": { locale: Yt },
  "et-EE": { locale: Kt },
  "lt-LT": { locale: jt },
  "lv-LV": { locale: Ut }
};
function Fr({
  selectedDate: l,
  onDateChange: S,
  onMonthChange: B,
  markSundayRed: lt,
  strikeThroughDates: st,
  showDaysOutsideMonth: nt = !1,
  localeString: it,
  canSelectPastDates: ft,
  isExpanded: C = !0,
  dots: c,
  weekNumbers: a = !1,
  selectWeek: m = !1,
  shouldDisableDate: V,
  selectedMonth: W,
  dateRange: o,
  isRangeDate: $ = !1,
  onRangeChange: i,
  isDisabled: ct = !1,
  redDays: mt = [],
  disablePastMonths: Dt = !1,
  disableBackwardNavigation: ht = !1,
  disableForwardNavigation: pt = !1
}) {
  const [s, b] = Q(W || l || /* @__PURE__ */ new Date()), [F, M] = Q(!0), { locale: D } = or[it];
  Tt(() => {
    l && b(W || l || /* @__PURE__ */ new Date());
  }, [C]);
  const ut = (r) => {
    b(r), B && B(r);
  }, G = (r) => {
    if (F)
      i && i({ startDate: r, endDate: null }), M(!1);
    else if (o?.startDate && o.startDate > r)
      i && i({ startDate: r, endDate: null }), M(!1);
    else {
      if (o?.startDate && f(r, o.startDate))
        return;
      if (o?.startDate && i) {
        const e = { startDate: o.startDate, endDate: r };
        i(e);
      }
      M(!0);
    }
  }, p = Lt(
    (r) => {
      $ ? G(r) : S && S(r);
    },
    [S, $, F, G]
  );
  function dt() {
    const r = Qt(/* @__PURE__ */ new Date(), { locale: D });
    return Array.from({ length: 7 }, (e, t) => R(tt(r, t), "eee", { locale: D }));
  }
  const yt = R(x(s), "MMMM yyyy", {
    locale: D
  }), St = N(s).getDate(), Ct = [a ? "v." : void 0, ...dt()], Mt = D.options?.weekStartsOn || 0, T = (x(s).getDay() - Mt + 7) % 7, Ot = (7 - N(s).getDay()) % 7, gt = ["auto", "auto", "100%"], kt = ["auto", "auto", "100%"], It = (r) => !ft && Ht(r) ? !0 : V ? V(r) : !1, vt = Array.from({ length: St + T + Ot }, (r, e) => {
    const t = tt(x(s), e - T), wt = rt(t, s), O = f(t, /* @__PURE__ */ new Date()), u = It(t) || ct, L = h(t, c?.yellowDotDates), E = h(t, c?.greenDotDates), P = h(t, c?.blueDotDates), _ = h(t, c?.redDotDates), z = h(t, c?.greyDotDates), A = _t(t, st) && !u;
    let g = !1;
    l && (g = f(t, l));
    const xt = t.getDay() === 0, H = mt.some(($t) => f($t, t)) || (lt ?? !1) && xt, k = et(t);
    let d = !1;
    m && l && (d = et(l) === k);
    const U = !rt(t, s), j = !!(o?.startDate && o?.endDate && t > o.startDate && t < o.endDate);
    let I = !1;
    o?.startDate && (I = f(t, o?.startDate));
    let v = !1, K = !1;
    o?.endDate && (v = f(t, o?.endDate), K = !0);
    const Bt = Z(
      g || d,
      O,
      U,
      j,
      I,
      v,
      K
    ), Vt = zt(d, O), Wt = Z(
      g || d,
      O,
      U,
      j,
      I,
      v
    ), Y = Math.floor(e / 7) + 1, y = e % 7 + 1;
    return a ? /* @__PURE__ */ w(Gt.Fragment, { children: [
      a && e % 7 === 0 && /* @__PURE__ */ n(
        q,
        {
          gridColumn: 1,
          gridRow: "1 / span 7",
          opacity: "0.24",
          borderRight: "1px solid",
          borderColor: ot.OnSurfaceBorder
        },
        `grid-${e}-${t}`
      ),
      a && e % 7 === 0 && /* @__PURE__ */ n(
        Pt,
        {
          handleWeekChange: p,
          date: t,
          gridIndex: e,
          variant: Vt,
          selectWeek: m,
          isDisabled: u
        },
        `week-${e}-${k}`
      ),
      /* @__PURE__ */ n(
        X,
        {
          hasBlueDot: P,
          hasGreenDot: E,
          hasYellowDot: L,
          hasRedDot: _,
          hasGreyDot: z,
          gridIndex: e,
          gridColumn: a ? y + 2 : y,
          gridRow: Y,
          day: t,
          handleDateChange: p,
          variant: Wt,
          isDisabled: u,
          isStrikeThrough: A,
          selectWeek: m,
          isHoliday: H
        },
        t.toString() + e
      )
    ] }, `fragment-${e}-${k}`) : wt || nt ? /* @__PURE__ */ n(
      X,
      {
        hasBlueDot: P,
        hasGreenDot: E,
        hasYellowDot: L,
        hasRedDot: _,
        hasGreyDot: z,
        gridIndex: e,
        gridColumn: a ? y + 1 : y,
        gridRow: Y,
        day: t,
        handleDateChange: p,
        variant: Bt,
        isDisabled: u,
        isStrikeThrough: A,
        selectWeek: m,
        isHoliday: H
      },
      `${t.toString()}-${e}`
    ) : null;
  });
  return /* @__PURE__ */ w(Ft, { w: kt, h: gt, children: [
    /* @__PURE__ */ n(
      Et,
      {
        selectedDate: l || /* @__PURE__ */ new Date(),
        onDateChange: p,
        isExpanded: C,
        onMonthChange: ut,
        selectedMonth: s,
        month: yt,
        locale: D,
        selectWeek: m,
        disablePastMonths: Dt,
        disableBackwardNavigation: ht,
        disableForwardNavigation: pt,
        dateRange: o,
        onRangeChange: i
      }
    ),
    C && /* @__PURE__ */ w(bt, { children: [
      /* @__PURE__ */ n(J, { templateColumns: a ? "48px 1px 1fr 1fr 1fr 1fr 1fr 1fr 1fr" : "repeat(7, 1fr)", children: Ct.map((r, e) => {
        let t;
        return a && e === 0 ? t = 1 : a ? t = e + 2 : t = e, r ? /* @__PURE__ */ n(
          q,
          {
            textAlign: "center",
            fontWeight: "500",
            fontFamily: er.Body,
            fontSize: rr.Small,
            gridColumn: t,
            borderRight: a && e === 0 ? `1px solid ${ot.OnSurfaceBorder}` : "",
            pb: at.Small,
            children: At(r).slice(0, 2)
          },
          r
        ) : null;
      }) }),
      /* @__PURE__ */ n(
        J,
        {
          templateColumns: a ? "48px 1px 1fr 1fr 1fr 1fr 1fr 1fr 1fr" : "repeat(7, 1fr)",
          rowGap: at.Small,
          flexShrink: 1,
          children: vt
        }
      )
    ] })
  ] });
}
export {
  Fr as BaseDatePicker
};
